/* eslint-disable */
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';
import { IReply } from 'src/interfaces';
import SupportDeskService from 'src/services/support-desk.service';

export const useAddSupportTicketReply = (): UseMutationResult<
  any,
  Error,
  { ticketId: string; ticket: FormData },
  void
> =>
  useMutation(
    ({ ticketId, ticket }: { ticketId: string; ticket: FormData }) =>
      SupportDeskService.addSupporTicketReply(ticketId, ticket),
    {
      onSuccess: () => {
        AlertAdapter('Reply Succefully Sent', 'success');
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );

export const useUpdateSupportTicketStatus = (): UseMutationResult<
  any,
  Error,
  { ticketId: string; status: string },
  void
> =>
  useMutation(
    ({ ticketId, status }: { ticketId: string; status: string }) =>
      SupportDeskService.updateSupportTicketStatus(ticketId, status),
    {
      onSuccess: () => {
        AlertAdapter('Status Updated Successfully', 'success');
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );

export const useReopenticket = (): UseMutationResult<any, Error, { ticketId: string; ticket: IReply }, void> =>
  useMutation(
    ({ ticketId, ticket }: { ticketId: string; ticket: IReply }) => SupportDeskService.reopenTicket(ticketId, ticket),
    {
      onSuccess: () => {
        AlertAdapter('Ticket Successfully Reopened', 'success');
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );

export const useAssignUser = (): UseMutationResult<any, Error, { assignUser: any }, void> =>
  useMutation(({ assignUser }: { assignUser: any }) => SupportDeskService.assignUser(assignUser), {
    onSuccess: () => {
      AlertAdapter('User updated Successfully', 'success');
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });

export const useUpdateSupportTicket = (): UseMutationResult<any, Error, { ticketId: string; updateData: any }, void> =>
  useMutation(
    ({ ticketId, updateData }: { ticketId: string; updateData: any }) =>
      SupportDeskService.updateSupportTicket(ticketId, updateData),
    {
      onSuccess: () => {
        AlertAdapter('Status Updated Successfully', 'success');
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );
